exports.default = {
  'agent_center': '智能体中心',
  'create_agent': '新建智能体',
  'search_results': '{keyword}的搜索结果',
  'found_agents': '（找到{count}个相关智能体）',
  'no_search_results': '暂无搜索结果，换个词试试',
  'relevance': '相关性',
  'most_popular': '最受欢迎',
  'latest_released': '最近发布',
  'i_created': '我的',
  'your_agents': '您的智能体',
  'loading': '加载中',
  'no_more': '没有更多了',
  'settings': '设置',
  'delete': '删除',
  'confirm_delete_agent': '确定删除智能体？',
  'delete_agent_warning': '删除智能体将无法撤销。用户将不能访问你的智能体，所有 Prompt 编排配置和日志均将一并被删除。',
  'subscription_incomplete': '订阅未完成，稍后请查看账单',
  'order_cancelled': '订单已取消',
  'no_custom_agents': '暂无自定义智能体'
}
